import { ArrowRight } from 'lucide-react';

import { operationFor } from '../../lib/spans.js';

/**
 * What this tag will actually do to the caption, spelled out.
 *
 * The action is derived rather than chosen, so it has to be *shown* - a label reading
 * "remove" tells you the name of the operation, not what the sentence will read like
 * afterwards. This renders the before → after directly.
 *
 * Used by the span list, the per-tag panels and the in-place editor so all three say
 * the same thing.
 */
export function SpanOutcome({ span, compact = false }) {
  const operation = operationFor(span?.label, span || {});
  const text = span?.text || '';

  if (operation === 'replace') {
    return (
      <div className={`span-outcome op-replace ${compact ? 'compact' : ''}`}>
        <s>{text}</s>
        <ArrowRight size={13} aria-label="becomes" />
        <strong>{span.replacement_text}</strong>
      </div>
    );
  }

  if (operation === 'remove') {
    return (
      <div className={`span-outcome op-remove ${compact ? 'compact' : ''}`}>
        <s>{text}</s>
        <span>deleted from the final caption</span>
      </div>
    );
  }

  const note = String(span?.notes || '').trim();
  return (
    <div className={`span-outcome op-keep_with_uncertainty_note ${compact ? 'compact' : ''}`}>
      <strong>{text}</strong>
      {note ? (
        <em>&lt;{note}&gt;</em>
      ) : (
        <span className="outcome-missing">kept — note still needed</span>
      )}
    </div>
  );
}
